import { createStore } from 'redux';
import rootReducer from '../reducers';

const store = createStore(rootReducer); //creating a store - this is were we hold the application state

export default store;
